/**
 * The listing filters (type, untagged, favourites, sort) that should survive a
 * move to another folder: picking PDFs and then a folder means PDFs in that
 * folder. Anything else in the URL (search terms, artwork codes) is dropped.
 */
const KEEP = ['kind', 'sort', 'order', 'untagged', 'favourites'] as const;

export function keepBrowseFilters(prev: Record<string, unknown>) {
  const out: Record<string, unknown> = {};
  for (const k of KEEP) if (prev[k] !== undefined) out[k] = prev[k];
  return out;
}
